import {cubicOut} from "svelte/easing";

const defs = {
  delay: 0,
  duration: 400,
  easing: cubicOut
}

const commonStyle = "position: relative; z-index: -1;"; 


export const flyRight = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const width = node.clientWidth;
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const marginLeft = parseFloat(style.marginLeft);
  const marginRight = parseFloat(style.marginRight);
  
  const total = width + marginRight + marginLeft;

  const css = (t, u) => `
    ${commonStyle}
    margin-left: ${marginLeft - total * u}px; 
    opacity: ${t * opacity};`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}

export const slideRight = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const width = node.clientWidth;
  const style = getComputedStyle(node);
  const marginLeft = parseFloat(style.marginLeft);
  const marginRight = parseFloat(style.marginRight);
  
  const total = width + marginRight + marginLeft;

  const css = (t, u) => `${commonStyle} margin-left: ${marginLeft - total * u}px;`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}


export const flyLeft = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const width = node.clientWidth;
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const marginLeft = parseFloat(style.marginLeft);
  const marginRight = parseFloat(style.marginRight);
  
  const total = width + marginRight + marginLeft;

  const css = (t, u) => `
    ${commonStyle}  
    margin-right: ${marginRight - total * u}px; 
    opacity: ${t * opacity};`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}

export const slideLeft = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const width = node.clientWidth;
  const style = getComputedStyle(node);
  const marginLeft = parseFloat(style.marginLeft);
  const marginRight = parseFloat(style.marginRight);
  const total = width + marginRight + marginLeft;
  
  const css = (t, u) => `${commonStyle} margin-right: ${marginRight - total * u}px;`
  
  return {
    easing,
    duration,
    delay,
    css
  }
}

export const flyDown = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const width = node.clientHeight;
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const marginTop = parseFloat(style.marginTop);
  const marginBottom = parseFloat(style.marginBottom);
  
  const total = width + marginTop + marginBottom;

  const css = (t, u) => `
  ${commonStyle}
    margin-top: ${marginTop - total * u}px; 
    opacity: ${t * opacity};`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}

export const slideDown = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const height = node.clientHeight;
  const style = getComputedStyle(node);
  const marginTop = parseFloat(style.marginTop);
  const marginBottom = parseFloat(style.marginBottom);
  
  const total = height + marginTop + marginBottom;

  const css = (t, u) => `${commonStyle} margin-top: ${marginTop - total * u}px;`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}

export const flyUp = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const height = node.clientHeight;
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const marginTop = parseFloat(style.marginTop);
  const marginBottom = parseFloat(style.marginBottom);
  
  const total = height + marginTop + marginBottom;

  const css = (t, u) => `
  ${commonStyle}
    margin-bottom: ${marginBottom - total * u}px; 
    opacity: ${t * opacity};`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}


export const slideUp = (node, params = {}) => {
  const {easing, duration, delay} = {...defs, ...params};
  const height = node.clientHeight;
  const style = getComputedStyle(node);
  const marginTop = parseFloat(style.marginTop);
  const marginBottom = parseFloat(style.marginBottom);
  
  const total = height + marginTop + marginBottom;

  const css = (t, u) => `${commonStyle} margin-bottom: ${marginBottom - total * u}px;`;
  
  return {
    easing,
    duration,
    delay,
    css
  }
}

